var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapacityManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0465 1.60156L1.0465 24.4016M18.0636 4.8949L18.0636 2.86823C18.0636 2.17156 17.4636 1.60156 16.7303 1.60156L6.37984 1.60156C5.6465 1.60156 5.0465 2.17156 5.0465 2.86823L5.0465 4.8949C5.0465 5.59156 5.6465 6.16156 6.37983 6.16156L16.7303 6.16156C17.4636 6.16156 18.0636 5.59156 18.0636 4.8949ZM22.317 14.0149L22.317 11.9882C22.317 11.2916 21.717 10.7216 20.9836 10.7216L6.37983 10.7216C5.6465 10.7216 5.0465 11.2916 5.0465 11.9882L5.0465 14.0149C5.0465 14.7116 5.6465 15.2816 6.37983 15.2816L20.9836 15.2816C21.717 15.2816 22.317 14.7116 22.317 14.0149ZM26.5703 23.1349L26.5703 21.1082C26.5703 20.4116 25.9703 19.8416 25.237 19.8416L6.37983 19.8416C5.6465 19.8416 5.0465 20.4116 5.0465 21.1082L5.0465 23.1349C5.0465 23.8316 5.6465 24.4016 6.37983 24.4016L25.237 24.4016C25.9703 24.4016 26.5703 23.8316 26.5703 23.1349Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacityManagement);
export default __webpack_public_path__ + "static/media/CapacityManagement.9ce35d8d258504bed492ac702c955a50.svg";
export { ForwardRef as ReactComponent };